module.exports = __webpack_public_path__ + "images/emoji/smile.fcf7247755f5fa248687.png";